const genderOptions = [
  { id: 2, name: 'Feminino' },
  { id: 1, name: 'Masculino' },
  { id: 3, name: 'Não informado' },
];

export default genderOptions;
